var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSignupTermCheckedDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_622_5839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.21662 14.9999C8.10235 14.9996 7.98938 14.9757 7.88473 14.9298C7.78008 14.8839 7.68598 14.817 7.60828 14.7333L3.55828 10.4249C3.40689 10.2636 3.32579 10.0487 3.33282 9.82758C3.33985 9.60644 3.43444 9.39715 3.59578 9.24576C3.75712 9.09436 3.972 9.01326 4.19313 9.02029C4.41427 9.02733 4.62356 9.12192 4.77495 9.28326L8.20828 12.9416L15.2166 5.27493C15.2877 5.18636 15.3762 5.11327 15.4766 5.06014C15.577 5.00702 15.6872 4.97498 15.8004 4.96599C15.9137 4.957 16.0275 4.97126 16.1351 5.00788C16.2426 5.04451 16.3415 5.10273 16.4257 5.17896C16.5099 5.2552 16.5776 5.34785 16.6247 5.45121C16.6718 5.55458 16.6973 5.66648 16.6995 5.78004C16.7018 5.89361 16.6808 6.00644 16.6379 6.1116C16.595 6.21677 16.531 6.31205 16.4499 6.39159L8.83328 14.7249C8.75632 14.8102 8.66255 14.8787 8.55786 14.926C8.45317 14.9733 8.33983 14.9985 8.22495 14.9999H8.21662Z",
    fill: "#DBDCDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_622_5839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignupTermCheckedDisable);
export default __webpack_public_path__ + "static/media/icon_signup_termChecked_disable.681b63c2d5e476b0a7d05e1b319e4061.svg";
export { ForwardRef as ReactComponent };